'use strict';

var promise = require('bluebird');

module.exports = function () {
    var localizedKeys = {};

    /**
     * Attempts to get the value by key from the appropriate lang and cntry JSON object.  If it
     * does not find the appropriate file, it attempts to use the default that you NEED to setup.
     * @param key key used to fetch the value from the JSON object
     * @param lang language you want
     * @param cntry country you want
     * @returns {string} value of the key by lang and cntry
     */
    this.get = function (key, lang, cntry) {
        var dataKey = createKey(lang, cntry);
        var keys = localizedKeys[dataKey];
        if (!keys) {
            //console.log('LocalizationManager: could not find json data for ' + dataKey);
            keys = localizedKeys.default;
            if (!keys) {
                console.log('Could not find default localization data.  Be sure you have provided this as a backup');
                return '';
            }
        }

        if (keys[key]) return keys[key];else {
            keys = localizedKeys.default;
            if (keys && keys[key] !== undefined) {
                return keys[key];
            }

            console.log('Could not find default localization key "' + key + '".');
            return '';
        }
    };

    /**
     * Used to set the default list of key / values
     * @param {object} JSON object of keys and values
     */
    this.setDefault = function (data) {
        localizedKeys.default = data;
    };

    /**
     * Used to set data if you want to do this manually
     * @param lang
     * @param cntry
     * @param data
     */
    this.set = function (lang, cntry, data) {
        localizedKeys[createKey(lang, cntry)] = data;
    };

    function createKey(lang, cntry) {
        return lang + '_' + cntry;
    };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/localization/LocalizationManager.js
// module id = 271
// module chunks = 0